import React from 'react';

import { CostPerPlay } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';

import { IPrsDeductionCap } from 'src/types/IRateCard';
import { getConversionModel } from 'src/util/RateCards';

import { ViewConversionModel } from '../ViewConversionModel';
import { ViewCustomerType } from '../ViewCustomerType';
import { ViewPlayType } from '../ViewPlayType';
import { ViewCapPRSDeduction } from './ViewCapPRSDeduction';
import './ViewCostPerPlay.scss';
import { ViewProgramType } from './ViewProgramType';

interface IViewCostPerPlayProps {
    costPerPlay: CostPerPlay;
    prsDeductionCap: IPrsDeductionCap;
    serviceId: number;
}

export const ViewCostPerPlay = ({ costPerPlay, serviceId, prsDeductionCap }: IViewCostPerPlayProps) => {
    return (
        <Column>
            <Text type="h500">Cost per play terms</Text>
            <ViewPlayType playTypes={costPerPlay.playTypes} />
            <ViewCustomerType customerTypes={costPerPlay.customerTypes} />
            <ViewProgramType programTypeList={costPerPlay.programTypeList} />
            <ViewCapPRSDeduction prsDeductionCap={prsDeductionCap} />
            <ViewConversionModel
                conversion={getConversionModel(costPerPlay.conversions)}
                guardrailConversion={getConversionModel(costPerPlay.conversions, false, true)}
                serviceId={serviceId}
            />
        </Column>
    );
};
